<script>
import { useAlert } from 'dashboard/composables';
import { mapGetters } from 'vuex';
import WebhookForm from './WebhookForm.vue';
import EditSheet from 'dashboard/components-next/polaris/cards/EditSheet.vue';

// Phase 9.9 (R2-9-5: webhook = drawer): editing a webhook in the kit's EditSheet.
export default {
  components: { WebhookForm, EditSheet },
  props: {
    value: {
      type: Object,
      required: true,
    },
    id: {
      type: [Number, String],
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  data() {
    return { snapshot: '', current: '' };
  },
  computed: {
    ...mapGetters({ uiFlags: 'webhooks/getUIFlags' }),
    dirty() {
      return this.current !== this.snapshot;
    },
    scope() {
      return `${this.$t('SIDEBAR.SETTINGS')} · ${this.$t('INTEGRATION_SETTINGS.WEBHOOK.TITLE')}`;
    },
  },
  methods: {
    onChange(json) {
      if (!this.snapshot) this.snapshot = json;
      this.current = json;
    },
    runGuarded(action) {
      return this.$refs.sheet ? this.$refs.sheet.runGuarded(action) : action();
    },
    async onSubmit(webhook) {
      try {
        await this.$store.dispatch('webhooks/update', {
          webhook,
          id: this.id,
        });
        useAlert(
          this.$t('INTEGRATION_SETTINGS.WEBHOOK.EDIT.API.SUCCESS_MESSAGE')
        );
        this.onClose();
      } catch (error) {
        const alertMessage =
          error?.response?.data?.message ||
          this.$t('INTEGRATION_SETTINGS.WEBHOOK.EDIT.API.ERROR_MESSAGE');
        useAlert(alertMessage);
      }
    },
  },
};
</script>

<template>
  <EditSheet
    ref="sheet"
    open
    :title="$t('INTEGRATION_SETTINGS.WEBHOOK.EDIT.TITLE')"
    :scope="scope"
    :dirty="dirty"
    :save-label="$t('INTEGRATION_SETTINGS.WEBHOOK.FORM.EDIT_SUBMIT')"
    :can-save="!uiFlags.updatingItem"
    @update:open="value => !value && onClose()"
    @save="$refs.form.onSubmit()"
  >
    <WebhookForm
      ref="form"
      :value="value"
      @submit="onSubmit"
      @change="onChange"
    />
  </EditSheet>
</template>
